import styled from "styled-components";
import DefaultContainer from "./DefaultContainer";

const Container = styled.footer`
  background-color: #0f172a;
  padding: 60px 0;
  color: #94a3b8;
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 48px 0;
  }
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const BrandName = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: #ffffff;
`;

const BrandTagline = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: #64748b;
  margin-top: 8px;
`;

const LinksSection = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

const FooterLink = styled.a`
  color: #94a3b8;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s ease;

  &:hover {
    color: #ffffff;
  }
`;

const BottomSection = styled.div`
  padding-top: 32px;
  border-top: 1px solid #1e293b;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #475569;
`;

const Informations = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Footer = () => {
  return (
    <Container>
      <DefaultContainer>
        <Contents>
          <div>
            <BrandName>Following Moments</BrandName>
            <BrandTagline>
              장소를 따라, 순간을 기록하다
            </BrandTagline>
          </div>

          <LinksSection>
            <FooterLink
              href="https://lone.followingmoments.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              LoNe
            </FooterLink>
            <FooterLink
              href="https://apps.apple.com/us/app/lone/id6757098843"
              target="_blank"
              rel="noopener noreferrer"
            >
              App Store
            </FooterLink>
            <FooterLink
              href="https://play.google.com/store/apps/details?id=com.followingmoments.lone&hl=ko"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Play
            </FooterLink>
            <FooterLink
              href="https://lone.followingmoments.com/terms/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              개인정보처리방침
            </FooterLink>
            <FooterLink href="mailto:contact@followingmoments.com">
              이메일
            </FooterLink>
          </LinksSection>

          <BottomSection>
            <Informations>
              <div>사업자번호: 624-01-03208 | 통신판매업: 2024-용인기흥-0606</div>
              <div>주소: 경기도 용인시 기흥구 강남서로 9</div>
            </Informations>
            <div>
              &copy; 2025 Following Moments. All rights reserved.
            </div>
          </BottomSection>
        </Contents>
      </DefaultContainer>
    </Container>
  );
};

export default Footer;
